module.exports = __webpack_public_path__ + "static/img/yeswecan0026.b84f5f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0026.png
// module id = 592
// module chunks = 1